// extracted by mini-css-extract-plugin
var _1 = "ErrorIcon__errorFallback--SSLTZ";
var _2 = "ErrorIcon__errorFallbackMark--BiQEg";
var _3 = "ErrorIcon__errorFallbackTriangle--JKp9D";
var _4 = "ErrorIcon__errorIcon--y7xkj";
var _5 = "ErrorIcon__errorImg--LFHL6";
export { _1 as "errorFallback", _2 as "errorFallbackMark", _3 as "errorFallbackTriangle", _4 as "errorIcon", _5 as "errorImg" }
